import * as reduxAction from 'redux-actions';
import { IActivityThemeModel } from './ActivityTheme';

export const WEB_GET_ACTIVITY_THEMES = 'ACTIVITYTHEME.WEB_GET_ACTIVITY_THEMES'
export const WEB_REFETCH_ACTIVITY_THEMES = 'ACTIVITYTHEME.WEB_REFETCH_ACTIVITY_THEMES'
export const WEB_GET_ACTIVITY_THEMES_SUCCEEDED = 'ACTIVITYTHEME.WEB_GET_ACTIVITY_THEMES_SUCCEEDED'
export const WEB_GET_ACTIVITY_THEMES_FAILED = 'ACTIVITYTHEME.WEB_GET_ACTIVITY_THEMES_FAILED'


export function webGetActivityThemesAction():any{
    return reduxAction.createAction(WEB_GET_ACTIVITY_THEMES)()
}
export function webRefetchActivityThemesaction():any{
    return reduxAction.createAction(WEB_REFETCH_ACTIVITY_THEMES)()
}
export function setActivityThemesAction(data: IActivityThemeModel[]):any{
    return reduxAction.createAction(WEB_GET_ACTIVITY_THEMES_SUCCEEDED)(data)
}
export function getActivityThemesFailedAction(msg: string):any{
    return reduxAction.createAction(WEB_GET_ACTIVITY_THEMES_FAILED)(msg)
}




// WEBPACK FOOTER //
// ./src/Entities/ActivityTheme/ActivityTheme.Actions.ts